import React from "react";

const IconLock = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 15.239 17.381">
      <g
        id="Group_2048"
        dataname="Group 2048"
        transform="translate(9474.275 -1672.295)"
      >
        <g
          id="Group_813"
          dataname="Group 813"
          transform="translate(-9474.275 1678.906)"
        >
          <path
            id="Path_3468"
            dataname="Path 3468"
            d="M196.36,399.988H186.189a2.537,2.537,0,0,1-2.534-2.534v-5.7a2.537,2.537,0,0,1,2.534-2.534H196.36a2.537,2.537,0,0,1,2.533,2.534v5.7A2.536,2.536,0,0,1,196.36,399.988Zm-10.171-9.848a1.615,1.615,0,0,0-1.613,1.613v5.7a1.615,1.615,0,0,0,1.613,1.614H196.36a1.615,1.615,0,0,0,1.612-1.614v-5.7a1.615,1.615,0,0,0-1.612-1.613Z"
            transform="translate(-183.655 -389.219)"
          />
        </g>
        <g
          id="Group_814"
          dataname="Group 814"
          transform="translate(-9470.541 1672.295)"
        >
          <path
            id="Path_3469"
            dataname="Path 3469"
            d="M196.289,387.9h-.921v-3.409a2.964,2.964,0,0,0-5.927,0v3.257h-.921v-3.257a3.885,3.885,0,0,1,7.769,0Z"
            transform="translate(-188.52 -380.607)"
          />
        </g>
        <g
          id="Group_815"
          dataname="Group 815"
          transform="translate(-9471.169 1683.213)"
        >
          <ellipse
            id="Ellipse_183"
            dataname="Ellipse 183"
            cx="0.804"
            cy="0.804"
            rx="0.804"
            ry="0.804"
          />
        </g>
        <g
          id="Group_816"
          dataname="Group 816"
          transform="translate(-9468.679 1683.213)"
        >
          <ellipse
            id="Ellipse_184"
            dataname="Ellipse 184"
            cx="0.804"
            cy="0.804"
            rx="0.804"
            ry="0.804"
          />
        </g>
        <g
          id="Group_817"
          dataname="Group 817"
          transform="translate(-9466.188 1683.213)"
        >
          <ellipse
            id="Ellipse_185"
            dataname="Ellipse 185"
            cx="0.804"
            cy="0.804"
            rx="0.804"
            ry="0.804"
          />
        </g>
        <g
          id="Group_818"
          dataname="Group 818"
          transform="translate(-9463.698 1683.213)"
        >
          <ellipse
            id="Ellipse_186"
            dataname="Ellipse 186"
            cx="0.804"
            cy="0.804"
            rx="0.804"
            ry="0.804"
          />
        </g>
      </g>
    </svg>
  );
};

export default IconLock;
